import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

export const task: Task = {
  id: "673ec26e-3039-4ea2-a645-06c0de09b3ca",
  solutionType: "custom012100",
  type: "custom012100",
  options: {
    targetPointLocation: [2, 3],
  },
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "custom012100",
  data: {
    indexes: [
      [0, 0],
      [0, 1],
      [2, 0],
      [2, 1],
    ],
  },
};
